import ApplicationCooLayout from '../../layout/application-coo-layout';
import { Separator } from '../../components/separator';
import StagesFlow from '../../components/stages-flow/stages-flow';
import { useEffect, useMemo } from 'react';

import { useGetStagesApplicationQuery } from '../../redux/services/getStagesApplicationStatus';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import { openRouteStartCooApplication } from '../../redux/slices/routes-management-slice';
import { useGetCheckApplicantHasConsentStatusQuery } from '../../redux/services/getCheckApplicantHasConsentStatus';
import { useWindowScrollTo } from '../../hooks/use-initial-window-scroll-to';
import { P2TextDescription } from "react-bootstrap-common-script";
import { StagesEnum } from '../../components/stages-flow/stages/stages';
import { useNavigate } from 'react-router-dom';
import { trackerTrackingId } from '../../utils/wogaa-ids';
import { useWogaa } from '../../hooks/use-wogaa';
import config from '../../config';

function StagesProcess() {

  let navigate = useNavigate();

  const AppDispatch = useAppDispatch();
  const queryParameters = new URLSearchParams(window.location.search)
  const application_id = queryParameters.get("application_id");
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const { data, isLoading, isError } = useGetStagesApplicationQuery({application_id: application_id ?? "0", uinfin: loginUser?.uinfin ?? "", singpass_token: singpassToken ?? ""}, {skip: application_id === "0" || application_id === null});
  const shouldSkipConsentApiCall = application_id === "0" || application_id === null || isLoading || isError;
  const { data: applicantConsentData } = useGetCheckApplicantHasConsentStatusQuery({application_id: application_id ?? "0", uinfin: loginUser?.uinfin ?? "", singpass_token: singpassToken ?? ""}, {skip: shouldSkipConsentApiCall});
  const {toScroll} = useWindowScrollTo();
  const activeApplications = useAppSelector(state => state.app.ActiveApplicationsSlice.activeApplications);

  const isNewApplication = !application_id
  const applicationNotFound = !isNewApplication && isError

  if (!isLoading && applicationNotFound) {
    navigate("/");
  }

  useEffect(() => {
    toScroll();
  }, [isLoading]);

  const CurrentPolymerStatus = useMemo(()=>{
    return data?.polymer_status;
  },[data]);


  const currentApplicationStage = useMemo(() =>{
    switch(data?.application_status){
      case "SAVE_DRAFT":
        return "A";
      case "SUBMIT_COMPLETE":
        return "B";
      case "GATHER_CONSENT_COMPLETE":
        return "C";
      case "PENDING_PAYMENT":
        return "C";
      case "PAYMENT_COMPLETE":
        return "C";
      case "SENT_TO_BIOME":
      case "PENDING_APPLICANT_HDB_REVIEW":
      case "HDB_REVIEW":
      case "APPROVE":
      case "PENDING_BOOKING_APPOINTMENT":
      case "REVIEW_FINANCIAL_PLAN":
        return "D";
      case "PREPARE_FOR_COMPLETION":
      case "PREPARE_FOR_COMPLETION_COMPLETE":
        //NOTE: We checking using polymerStatus is because D2 and D3 next button will update the polymerStatus, So that they will go through all the D2 and D3 regardless of application status.
        // The scenario when prepare_for_completion status is assigned but applicant haven't completely go through D2 and D3 yet.
        // if (CurrentPolymerStatus === "E" || CurrentPolymerStatus === "E2") {
        //   return "E";
        // } else {
        //   return "D";
        // }

        // NOTE (7 FEB 2025):
        // Updated logic:
        // - Even if there is no HDB lawyer for conveyancing and no bank loan is present,
        //   the Biome system must update the status to APPROVE for the IPA.
        // - Only in no HDB lawyer scenario, will the Polymer frontend trigger the
        //   application status change to PREPARE_FOR_COMPLETION.
        return "E";
      default:
        return "A";
    }
  },[data,CurrentPolymerStatus]);

  useEffect(() => {
    // DISABLED to allow create multiple application when click on "Create new application" in dashbord page
    const allowMultipleApplicationDebug = config.allowMultipleApplicationDebug;
    const searchParams = new URLSearchParams(window.location.search)
    const applicationId = searchParams.get('application_id')
    console.log("allowMultipleApplicationDebug",allowMultipleApplicationDebug, activeApplications.length > 0, !activeApplications.some(item => item.application_id === applicationId));
    if(!allowMultipleApplicationDebug && activeApplications.length > 0 && !activeApplications.some(item => item.application_id === applicationId)){
      //redirect to the stage process for the first active applications to prevent user create new application by changing url
      console.log("Has existing application");
    }
    else{
      console.log("Allow bypass with existing application");
    }
  }, [activeApplications, navigate])

  useEffect(()=>{
    AppDispatch(openRouteStartCooApplication(true));
  },[])

  // WOGAA tracking for stages process - auto start and complete (page view tracking)
  useWogaa({
    trackingId: trackerTrackingId,
    autoStart: true,
    autoComplete: true,
    applicationId: application_id ?? undefined,
    hdbRef: data?.hdb_ref,
  });

  if (isLoading) {
    return <div className='polymer-start-application__loading'>Checking...</div>
  }

  if (!isError) {
    return (
      <ApplicationCooLayout>
        <div className='polymer-start-application-process-container'>
          <div>
            <p style={{ fontSize: "1.75rem", fontWeight: 700 }}>Application Process</p>
            <Separator />
          </div>
          <P2TextDescription color={'#333333'} description={'A change in flat ownership is a conveyancing procedure, similar to that of purchasing an HDB flat. You may refer to this process overview to complete the application for change in flat ownership.'} />
          <StagesFlow applicantConsentGiven={applicantConsentData?.consent_given} consentApplicant={applicantConsentData?.consent_application.owners_consent_status} activeStage={ currentApplicationStage as StagesEnum } stagesFlowCheckingData={data} applicationStatus={data?.application_status} polymerStatus={CurrentPolymerStatus}/>
        </div>
      </ApplicationCooLayout>
    )
  }

  return null
}

export default StagesProcess